module.exports = __webpack_public_path__ + "img/7.2e8d0474.jpg";